import React from "react";
import ReactModal from "react-modal";
import PropTypes from "prop-types";

const Modal = (props) => {
  const { children, isOpen, className = "" } = props;
  return (
    <ReactModal
      isOpen={isOpen}
      style={{ width: props.width }}
      // onClose={}
      className={className}
    >
      {children}
    </ReactModal>
  );
};

Modal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Modal;
